import {
    CorptaxHomeLogoLink,
    HeaderEndContainer,
    SiteHeader,
    useCometStyles,
    useCorptaxTheme,
    UserMenu,
} from '@corptax/react-components-common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetClaims } from '../../api/account/account';
import { useGetClaimsForCurrentUser } from '../../api/user-claims/user-claims';
import { useServiceDiscovery } from '../../hooks/useServiceDiscovery';
import { useTaxReturnCalculationState } from '../../hooks/useTaxReturnCalculationState';
import { IAppTheme } from '../../theme/IAppTheme';
import { replaceLocation } from '../../utils/LocationUtils';
import { getLogoutUrl } from '../../utils/Urls.constant';
import { getInitialsOfUserName } from '../../utils/UserUtils';

export const Topbar: FC = () => {
    const { t } = useTranslation();
    const claims = useGetClaims();
    const sessionId = claims.data?.find((c) => c.type === 'sid')?.value || '';
    const userClaims = useGetClaimsForCurrentUser();
    const userFullName = userClaims?.data?.userFullName || '';
    const { palette, customPalette } = useCorptaxTheme<IAppTheme>();
    const { homeUrl } = useServiceDiscovery();
    const { clearAllCompletedReports } = useTaxReturnCalculationState();

    const cometPalette = {
        darkPrimary: customPalette.themeDark,
        darkPrimaryAlt: customPalette.themeDarkAlt,
        lightPrimary: palette.white,
        lightPrimaryAlt: palette.neutralLighter,
    };

    const styleHelper = useCometStyles(cometPalette);

    return (
        <SiteHeader data-testid='topbar' styleHelper={styleHelper}>
            <CorptaxHomeLogoLink logoHref={homeUrl ?? '/'} />
            <h3 style={{ color: palette.white, marginLeft: '1.7rem', fontWeight: '600', fontSize: '1.15rem', lineHeight: '1.5rem' }}>
                {t('review')}
            </h3>
            <HeaderEndContainer>
                <UserMenu
                    styleHelper={styleHelper}
                    userActionMenuItems={[
                        {
                            ariaLabel: t('logout').toString(),
                            key: 'logOut',
                            onClick: () => {
                                clearAllCompletedReports();
                                replaceLocation(getLogoutUrl(sessionId));
                            },
                            text: t('logout').toString(),
                        },
                    ]}
                    userInfo={{
                        displayInitials: getInitialsOfUserName(userFullName),
                        displayName: userFullName,
                        secondaryText: userFullName,
                    }}
                />
            </HeaderEndContainer>
        </SiteHeader>
    );
};
